import { MenuItem } from "@chakra-ui/react";
import { VThreeDotMenu } from "components/Menu/ThreeDotMenu";
import MenuItemIcon from "components/Icon/MenuItemIcon";
import { User } from "features/User/models";
import { FiEdit, FiUserX, FiShield } from "react-icons/fi";

interface WorkforceTableRowMenuProps {
  user: User;
  size?: string;
  onEditProfile?: (userId: string) => void;
  onUpdateRoles?: (userId: string) => void;
  onDeactivate?: (userId: string) => void;
}

export default function WorkforceTableRowMenu({
  user,
  size = "xs",
  onEditProfile,
  onUpdateRoles,
  onDeactivate,
}: WorkforceTableRowMenuProps) {
  return (
    <VThreeDotMenu
      size={size}
      inPortal
      ariaLabel="User options"
      color="gray.600"
      _hover={{ color: "gray.800" }}
    >
      <MenuItem
        icon={<MenuItemIcon icon={FiEdit} />}
        onClick={() => onEditProfile?.(user.id)}
      >
        Edit Profile
      </MenuItem>

      <MenuItem
        icon={<MenuItemIcon icon={FiShield} />}
        onClick={() => onUpdateRoles?.(user.id)}
      >
        Update Roles
      </MenuItem>

      {!user.deactivatedAt && (
        <MenuItem
          icon={<MenuItemIcon icon={FiUserX} />}
          onClick={() => onDeactivate?.(user.id)}
        >
          Deactivate User
        </MenuItem>
      )}
    </VThreeDotMenu>
  );
}
